import { render, staticRenderFns } from "./SearchView.vue?vue&type=template&id=0c487e9f&"
import script from "./SearchView.vue?vue&type=script&lang=ts&"
export * from "./SearchView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c487e9f')) {
      api.createRecord('0c487e9f', component.options)
    } else {
      api.reload('0c487e9f', component.options)
    }
    module.hot.accept("./SearchView.vue?vue&type=template&id=0c487e9f&", function () {
      api.rerender('0c487e9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/SearchView.vue"
export default component.exports